$(function () {
  if (!customElements.get('product-media-endorsement')) {
    customElements.define(
      'product-media-endorsement',
      class ProductMediaEndorsement extends HTMLElement {
        constructor() {
          super();
          this.init();
        }

        init() {
          // 初始化tab切换
          this.initTabs();
          // 初始化所有swiper
          this.initSwipers();
          // 初始化媒体列表顺序
          this.initMediaOrder();
        }

        initMediaOrder() {
          const mediaContainers = this.querySelectorAll('.media-list-container');
          if (!mediaContainers.length) return;

          mediaContainers.forEach((mediaContainer) => {
            const mediaItems = [...mediaContainer.querySelectorAll('.media-item')];
            if (mediaItems.length === 0) return;

            // 如果总数大于等于5，保留5个
            if (mediaItems.length >= 5) {
              // 先克隆所有元素，避免直接操作原始DOM
              const clonedItems = mediaItems.map((item) => item.cloneNode(true));
              const activeItem = mediaContainer.querySelector('[data-active="true"]');
              if (!activeItem) return;

              const activeIndex = mediaItems.indexOf(activeItem);

              // 重新计算要显示的5个项目
              let selectedItems = [];

              // 确保激活项前有两个项目
              for (let i = 2; i > 0; i--) {
                const index = (activeIndex - i + mediaItems.length) % mediaItems.length;
                selectedItems.push(clonedItems[index]);
              }

              // 添加激活项
              selectedItems.push(clonedItems[activeIndex]);

              // 确保激活项后有两个项目
              for (let i = 1; i <= 2; i++) {
                const index = (activeIndex + i) % mediaItems.length;
                selectedItems.push(clonedItems[index]);
              }

              // 清空容器并添加重排后的元素
              mediaContainer.innerHTML = '';
              selectedItems.forEach((item) => {
                mediaContainer.appendChild(item);
              });
            }
            // 处理4个项目的情况
            else if (mediaItems.length === 4) {
              // 先克隆所有元素，避免直接操作原始DOM
              const clonedItems = mediaItems.map((item) => item.cloneNode(true));
              const activeItem = mediaContainer.querySelector('[data-active="true"]');
              if (!activeItem) return;

              const activeIndex = mediaItems.indexOf(activeItem);
              let selectedItems = [];

              if (activeIndex === 0) {
                // 如果第一个是激活项，将最后一个移到最前面
                selectedItems = [
                  clonedItems[3], // 最后一个
                  clonedItems[0], // 激活项
                  clonedItems[1],
                  clonedItems[2],
                ];
              } else if (activeIndex === 3) {
                // 如果最后一个是激活项，将第一个移到最后面
                selectedItems = [
                  clonedItems[1],
                  clonedItems[2], // 激活项
                  clonedItems[3],
                  clonedItems[0],
                ];
              } else {
                // 其他情况保持原始顺序
                selectedItems = [...clonedItems];
              }

              // 清空容器并添加重排后的元素
              mediaContainer.innerHTML = '';
              selectedItems.forEach((item) => {
                mediaContainer.appendChild(item);
              });
            }
            // 处理3个项目的情况
            else if (mediaItems.length === 3) {
              // 先克隆所有元素，避免直接操作原始DOM
              const clonedItems = mediaItems.map((item) => item.cloneNode(true));
              const activeItem = mediaContainer.querySelector('[data-active="true"]');
              if (!activeItem) return;

              const activeIndex = mediaItems.indexOf(activeItem);
              let selectedItems = [];

              if (activeIndex === 0) {
                // 如果第一个是激活项，将最后一个移到最前面
                selectedItems = [
                  clonedItems[2], // 最后一个
                  clonedItems[0], // 激活项
                  clonedItems[1],
                ];
              } else if (activeIndex === 2) {
                // 如果最后一个是激活项，将第一个移到最后面
                selectedItems = [
                  clonedItems[1],
                  clonedItems[2], // 激活项
                  clonedItems[0],
                ];
              } else {
                // 其他情况保持原始顺序
                selectedItems = [...clonedItems];
              }

              // 清空容器并添加重排后的元素
              mediaContainer.innerHTML = '';
              selectedItems.forEach((item) => {
                mediaContainer.appendChild(item);
              });
            }
          });
        }

        // 滚动元素到容器中间的通用函数
        scrollToCenter(element) {
          if (!element) return;

          // 获取最外层的可滚动容器
          const container = element.closest('.overflow-x-auto');
          if (!container) return;

          // 获取元素相对于可滚动容器的位置
          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          const elementRelativeLeft = elementRect.left - containerRect.left + container.scrollLeft;

          // 计算需要滚动的位置，使元素居中
          const scrollPosition = elementRelativeLeft - containerRect.width / 2 + elementRect.width / 2;

          // 使用平滑滚动
          container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
          });
        }

        initTabs() {
          const tabItems = this.querySelectorAll('.tabs-item');
          const tabSwiper = new Swiper(this.querySelector('.tab-swiper'), {
            allowTouchMove: false,
            on: {
              slideChange: function () {
                console.log('slideChange', this.realIndex);
                tabItems.forEach((tab, index) => {
                  if (index === this.realIndex) {
                    tab.classList.add('active');
                  } else {
                    tab.classList.remove('active');
                  }
                });
              },
            },
          });

          // 设置第一个tab为激活状态
          tabItems[0]?.classList.add('active');

          tabItems.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              // 移除所有tab的激活状态
              tabItems.forEach((item) => item.classList.remove('active'));
              // 添加当前tab的激活状态
              tab.classList.add('active');
              // 切换到对应的slide
              tabSwiper.slideTo(index);
              // 将点击的tab滚动到中间
              this.scrollToCenter(tab);
            });
          });
        }

        initSwipers() {
          const mediaSliders = this.querySelectorAll('.swiper-media');

          mediaSliders.forEach((slider) => {
            const mediaSwiper = new Swiper(slider, {
              loop: true,
              spaceBetween: 300,

              navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
              },
            });

            // 获取当前slider对应的logo容器组
            const mediaLogos = slider.closest('.swiper-slide').querySelectorAll('.media-logo');

            // 设置第一个logo的激活状态
            mediaLogos[0]?.classList.add('active');

            // 为每个logo添加点击事件
            mediaLogos.forEach((logo, index) => {
              logo.addEventListener('click', () => {
                mediaLogos.forEach((item) => item.classList.remove('active'));
                logo.classList.add('active');
                mediaSwiper.slideToLoop(index);
              });
            });

            // 监听slide切换事件
            mediaSwiper.on('slideChange', () => {
              mediaLogos.forEach((item) => item.classList.remove('active'));
              mediaLogos[mediaSwiper.realIndex]?.classList.add('active');
            });
          });
        }
      }
    );
  }
});
